var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 48,
    viewBox: "0 0 45 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7771 16.5181C39.7546 16.5181 39.7342 16.5243 39.7119 16.5245C40.1243 15.5705 40.3554 14.5196 40.3554 13.4143C40.3554 9.07959 36.8414 5.56552 32.5065 5.56552C30.9745 5.56552 29.5497 6.01137 28.3417 6.77033C26.7074 2.79862 22.8037 0 18.2425 0C12.2114 0 7.32222 4.88921 7.32222 10.9205C7.32222 11.3762 7.35873 11.8229 7.41318 12.2639C7.38235 12.2637 7.35283 12.2593 7.32222 12.2593C3.27835 12.2593 0 15.5374 0 19.5815C0 23.6252 3.27813 26.9033 7.32222 26.9033H39.7771C42.645 26.9033 44.97 24.5786 44.97 21.7106C44.97 18.8427 42.645 16.5179 39.7771 16.5179V16.5181Z",
    fill: "#BED7F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0359 30.0413L17.2249 38.6022H21.1008L18.5878 47.291L27.745 35.0245H23.0173L24.8062 30.0413H20.0359Z",
    fill: "#FCDB7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaios);
export default __webpack_public_path__ + "static/media/raios.afbb93fdf2e4f5063fbdf4b455f0dec4.svg";
export { ForwardRef as ReactComponent };